//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'IDOPEI',
  data () {
    return {
      form: {
        age: '',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        console.log(form)
        let result = (form.age / 4) + 4
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/IDOPEI.vue